import { Link } from 'react-router-dom';

const LINKS = [
  { to: '/terms', label: 'Terms', testid: 'legal-footer-terms' },
  { to: '/privacy', label: 'Privacy', testid: 'legal-footer-privacy' },
  { to: '/cookies', label: 'Cookie Policy', testid: 'legal-footer-cookies' },
  { to: '/dpa', label: 'DPA', testid: 'legal-footer-dpa' },
];

export function LegalFooter({ variant = 'inline' }) {
  const inlineCls =
    variant === 'inline'
      ? 'flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground'
      : 'flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-muted-foreground';

  return (
    <div className={inlineCls} data-testid="legal-footer">
      <span>© {new Date().getFullYear()} RotaHQ</span>
      {LINKS.map((l) => (
        <span key={l.to} className="inline-flex items-center gap-x-3">
          <span aria-hidden="true" className="opacity-50">·</span>
          <Link to={l.to} className="hover:text-foreground transition-colors hover:underline" data-testid={l.testid}>
            {l.label}
          </Link>
        </span>
      ))}
    </div>
  );
}

export default LegalFooter;
